module.exports = __webpack_public_path__ + "static/media/logo_trimex.5fa7a1b2.jpg";